import { Route, Routes } from "react-router-dom";

import {
  CLICK_AND_COLLECT_PATH,
  CROSSBAR_PATH,
  MAN_OF_THE_MATCH_PATH,
  PRONOSTIC_PATH,
  QUIZ_PATH,
  WALL_PATH,
  BINGO_GAME_PATH,
  HTML_PAGE_PATH,
  PRONOSTICSV2_PATH,
  FOODMENU_V2_PATH,
} from "_urls";

import { ClickAndCollectPDFPresenter } from "click-and-collect/views/ClickAndCollectPDFPresenter";
import { CrossbarRoutes } from "crossbar/routes/CrossbarRoutes";
import { EventPlayThemeWrapper } from "event/play/components/EventPlayThemeWrapper";
import { EventHomepageView } from "event/play/views/EventHomepageView";
import { PronosticView } from "event/play/views/PronosticView";
import ManOfTheMatchView from "event/play/views/ManOfTheMatchView";
import { WallPlayRoutes } from "wall/routes/WallPlayRoutes";
import { QuizGamePlayRoutes } from "quiz/routes/QuizGamePlayRoutes";
import { BingoGamePlayRoutes } from "bingo/routes/BingoGamePlayRoutes";
import { HtmlPageRoutes } from "htmlpage/routes/HtmlPageRoutes";
import { PronosticsV2Routes } from "pronosticsv2/routes/PronosticsV2Routes";
//import { EventQRScanView } from "event/play/views/EventQRScanView";
import { EventQRScanViewV2 } from "event/play/views/EventQRScanView2";
import FoodMenuV2 from "event/play/views/FoodMenuV2";

export function EventPlayRoutes() {
  return (
    <Routes>
      <Route path="/">
        <Route path="/" element={<EventQRScanViewV2 />} />
      </Route>

      <Route path=":eventId" element={<EventPlayThemeWrapper />}>
        <Route path={FOODMENU_V2_PATH} element={<FoodMenuV2 />} />
        <Route path="" element={<EventHomepageView />} />
        <Route path={PRONOSTIC_PATH} element={<PronosticView />} />
        <Route path={MAN_OF_THE_MATCH_PATH} element={<ManOfTheMatchView />} />
        <Route
          path={CLICK_AND_COLLECT_PATH}
          element={<ClickAndCollectPDFPresenter />}
        />

        <Route path={`${CROSSBAR_PATH}/*`} element={<CrossbarRoutes />} />
        <Route path={`${WALL_PATH}/*`} element={<WallPlayRoutes />} />
        <Route path={`${QUIZ_PATH}/*`} element={<QuizGamePlayRoutes />} />
        <Route
          path={`${BINGO_GAME_PATH}/*`}
          element={<BingoGamePlayRoutes />}
        />
        <Route path={`${HTML_PAGE_PATH}/*`} element={<HtmlPageRoutes />} />
        <Route
          path={`${PRONOSTICSV2_PATH}/*`}
          element={<PronosticsV2Routes />}
        />
      </Route>
    </Routes>
  );
}
